import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductPriceLines = _resolveComponent("ProductPriceLines")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_ProductPriceLines, {
      productId: _ctx.productId,
      dateStart: _ctx.dateStart,
      slotId: _ctx.slotId,
      editMode: true
    }, null, 8, ["productId", "dateStart", "slotId"])
  ]))
}